export default import.meta.ROLLDOWN_FILE_URL_0eOvlKAB$ygKBkFBiA0Vvg